import { ArrowCounterclockwise, ArrowUp, ArrowClockwise, ArrowLeft, ArrowDown, ArrowRight, ArrowsCollapse, ArrowsExpand, ArrowsCollapseVertical, ArrowsExpandVertical } from "react-bootstrap-icons";
import React from "react";
import { ObbAnnotation } from "../../api/Application";
import { modify } from "./Mode";
import { Mode, DrawingStateFns, ModeEdit } from "./ModeContext";

export function createEditMode( annotation?: ObbAnnotation ): ModeEdit {
    return { mode: Mode.Edit, annotation };
}

export const editModeFns: DrawingStateFns = {
    getCommandSlots( drawMode ) {
        return [
            { key: "q", label: "Rot-",  icon: React.createElement( ArrowCounterclockwise, { size: 20 } ), color: "white", active: false },
            { key: "w", label: "Up",    icon: React.createElement( ArrowUp,                { size: 20 } ), color: "white", active: false },
            { key: "e", label: "Rot+",  icon: React.createElement( ArrowClockwise,         { size: 20 } ), color: "white", active: false },
            null,
            null,

            { key: "a", label: "Left",  icon: React.createElement( ArrowLeft,  { size: 20 } ), color: "white", active: false },
            { key: "s", label: "Down",  icon: React.createElement( ArrowDown,  { size: 20 } ), color: "white", active: false },
            { key: "d", label: "Right", icon: React.createElement( ArrowRight, { size: 20 } ), color: "white", active: false },
            null,
            null,

            { key: "z", label: "W-",    icon: React.createElement( ArrowsCollapseVertical, { size: 20 } ), color: "white", active: false },
            { key: "x", label: "W+",    icon: React.createElement( ArrowsExpandVertical,   { size: 20 } ), color: "white", active: false },
            { key: "c", label: "H-",    icon: React.createElement( ArrowsCollapse,         { size: 20 } ), color: "white", active: false },
            { key: "v", label: "H+",    icon: React.createElement( ArrowsExpand,           { size: 20 } ), color: "white", active: false },
            null,
        ];
    },

    onKeyDown( drawMode, key, shift, ctx ) {
        const mode = drawMode as ModeEdit;
        if( mode.annotation === undefined ) {
            return false;
        }

        const xd = ( 1 / ( ctx.imageWidth  * ( shift ? 2 : 4 ) ) );
        const yd = ( 1 / ( ctx.imageHeight * ( shift ? 2 : 4 ) ) );
        const ad = ( shift ? 5 : 1 );

        if( key === "a" ) { ctx.setDrawMode( { ...mode, annotation: modify( mode.annotation, 0, 0, -xd,   0,   0 ) } ); return true; }
        if( key === "d" ) { ctx.setDrawMode( { ...mode, annotation: modify( mode.annotation, 0, 0,  xd,   0,   0 ) } ); return true; }
        if( key === "w" ) { ctx.setDrawMode( { ...mode, annotation: modify( mode.annotation, 0, 0,   0, -yd,   0 ) } ); return true; }
        if( key === "s" ) { ctx.setDrawMode( { ...mode, annotation: modify( mode.annotation, 0, 0,   0,  yd,   0 ) } ); return true; }
        if( key === "q" ) { ctx.setDrawMode( { ...mode, annotation: modify( mode.annotation, 0, 0,   0,   0, -ad ) } ); return true; }
        if( key === "e" ) { ctx.setDrawMode( { ...mode, annotation: modify( mode.annotation, 0, 0,   0,   0,  ad ) } ); return true; }

        //width
        if( key === "z" ) { ctx.setDrawMode( { ...mode, annotation: modify( mode.annotation, -xd, 0, 0, 0, 0 ) } ); return true; }
        if( key === "x" ) { ctx.setDrawMode( { ...mode, annotation: modify( mode.annotation,  xd, 0, 0, 0, 0 ) } ); return true; }

        //height
        if( key === "c" ) { ctx.setDrawMode( { ...mode, annotation: modify( mode.annotation, 0, -yd, 0, 0, 0 ) } ); return true; }
        if( key === "v" ) { ctx.setDrawMode( { ...mode, annotation: modify( mode.annotation, 0,  yd, 0, 0, 0 ) } ); return true; }

        if( key === "Delete" || key === "Backspace" ) {
            ctx.handleDelete( mode.annotation ).then(
                () => ctx.setDrawMode( { ...mode, annotation: undefined } ) );
            return true;
        }

        if( key === "Enter" ) {
            //
            ctx.handleEdit( { ...mode.annotation, attributes: { ...mode.annotation.attributes, parts: [] } } ).then(
                () => ctx.setDrawMode( { ...mode, annotation: undefined } ) );
            return true;
        }
        return false;
    },

    onDeckClick( drawMode, info, ctx ) {

    },

    onDeckHover( drawMode, info, ctx ) {

    },

    onAnnotationClick( drawMode, ann, ctx ) {
        ctx.setDrawMode( { mode: Mode.Edit, annotation: { ...ann } } );
    },

    filter( drawMode, ann ) {
        return true;
    },

    getLineColor( drawMode, ann, ctx ) {
        const mode = drawMode as ModeEdit;
        const { obbAnnotationId: id, attributes: attrs } = ann;        
        const editing  = id === mode.annotation?.obbAnnotationId;
        if( editing ) { return [   0,   0,   0,   0 ]; } //hidden because we show the edit layer
        return [ 0, 255, 0, 160 ];
    },

    getCursor( drawMode ) {
        return "grab";
    },

    getAnnotationLabel( drawMode, ann ) {
        return "";
    }
};